module.exports = __webpack_public_path__ + "img/编组 13.9707d3b5.png";